import React, { useEffect, useState } from 'react';
import { getLabRepeatOffenders } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function RepeatOffenderStepsPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getLabRepeatOffenders(sharedQuery).then((data) => setRows(data.rows || []));
  }, [sharedQuery]);

  return (
    <div className="lab-page">
      <LabCard title="Step recidivi" description="Classifica gli step che falliscono ripetutamente o accumulano pressione near-limit nel dataset.">
        <LabTable
          rows={rows}
          columns={[
            { key: 'stepName', label: 'Step' },
            { key: 'stepNumber', label: 'Step #' },
            { key: 'failCount', label: 'Conteggio fail' },
            { key: 'failRate', label: 'Fail rate %' },
            { key: 'nearLimitCount', label: 'Conteggio near-limit' },
            { key: 'affectedStations', label: 'Stazioni', render: (value) => (value || []).slice(0, 4).join(', ') || '—' },
            { key: 'classification', label: 'Classificazione', render: (value) => <LabRiskBadge label={value} /> },
            { key: 'repeatScore', label: 'Score recidiva' },
          ]}
        />
      </LabCard>
    </div>
  );
}
